import React from "react";
import EmojiGridCard from "./emoji-grid-card";

const EmojiGrid = ({ emojis }) => {
  return (
    <div>
      <ul className="list-unstyled row row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 no-break-ul">
        {emojis.map((emoji) => (
          <li key={emoji.codes} className="mb-4">
            <EmojiGridCard emoji={emoji}/>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default EmojiGrid;
